import React from "react";
import styles from "./Icons.module.scss";
import classNames from "classnames";

export const SolidCircleIcon = React.memo(({ bgColor = "i1", children }) => {
    return <div className={classNames(styles['solid-circle-icon'], styles[`bg-${bgColor}`])}>
        {children}
    </div>
});

export const SolidSquareIcon = React.memo(({ bgColor = "i1", children }) => {
    return <div className={classNames(styles['solid-square-icon'], styles[`bg-${bgColor}`])}>
        {children}
    </div>
});